import { normalizePhone, telHref, whatsappHref, formatPhoneDisplay } from '@/lib/phone';
import companyConfig, {
  PRIMARY_PHONE_DISPLAY,
  PRIMARY_PHONE_E164,
  PRIMARY_PHONE_LINK,
  PRIMARY_WHATSAPP_LINK,
} from '@/config/company';

/**
 * Coordonnées officielles — dérivées exclusivement de `companyConfig`
 * (source de vérité unique). Aucun numéro n'est déclaré ici.
 *
 * Le numéro secondaire (+243 819 919 510) n'est pas publié tant que
 * `companyConfig.secondaryPhone.verified` est faux : appels et WhatsApp
 * pointent donc sur le numéro principal +243 896 416 208.
 */
const AFAMEKIN2_PHONE_RAW = '+243898333056';

const assertPhone = (raw: string): string => {
  const e164 = normalizePhone(raw);
  if (!e164) throw new Error(`[contact] Invalid phone number constant: ${raw}`);
  return e164;
};

const AFAMEKIN2_PHONE = assertPhone(AFAMEKIN2_PHONE_RAW);

/** Ligne principale MTB BTP (appels) */
export const PHONE_NUMBER_E164 = PRIMARY_PHONE_E164;
export const PHONE_NUMBER_DISPLAY = PRIMARY_PHONE_DISPLAY;
export const PHONE_NUMBER_LINK = PRIMARY_PHONE_LINK;

/** WhatsApp principal — identique à la ligne principale */
export const WHATSAPP_NUMBER_E164 = companyConfig.whatsappNumber.raw;
export const WHATSAPP_NUMBER_DISPLAY = formatPhoneDisplay(companyConfig.whatsappNumber.raw);
export const WHATSAPP_LINK = PRIMARY_WHATSAPP_LINK;

/** Numéro secondaire — exposé seulement s'il est validé dans companyConfig. */
export const SECONDARY_PHONE_DISPLAY = companyConfig.secondaryPhone.verified
  ? formatPhoneDisplay(companyConfig.secondaryPhone.raw)
  : null;
export const SECONDARY_PHONE_LINK = companyConfig.secondaryPhone.verified
  ? (telHref(companyConfig.secondaryPhone.raw) as string)
  : null;

export const OFFICIAL_EMAIL = companyConfig.officialEmail;
export const FACEBOOK_LINK = companyConfig.socialLinks.facebook;
export const LINKEDIN_LINK = companyConfig.socialLinks.linkedin;

// Contact direct pour le pôle soudure / AFAMEKIN2 (sous-traitant partenaire).
// Ne doit jamais figurer dans les données structurées de MTB BTP.
export const AFAMEKIN2_PHONE_E164 = AFAMEKIN2_PHONE;
export const AFAMEKIN2_PHONE_DISPLAY = formatPhoneDisplay(AFAMEKIN2_PHONE);
export const AFAMEKIN2_PHONE_LINK = telHref(AFAMEKIN2_PHONE) as string;
export const AFAMEKIN2_WHATSAPP_LINK = whatsappHref(AFAMEKIN2_PHONE) as string;
